import { render, staticRenderFns } from "./subjectwise_content.vue?vue&type=template&id=6b7592cb&"
import script from "./subjectwise_content.vue?vue&type=script&lang=js&"
export * from "./subjectwise_content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports